const t = "af.sample-change", s = class s extends CustomEvent {
  constructor(a) {
    super(t, { detail: { sampleText: a }, bubbles: !0, composed: !0 });
  }
};
s.EVENT_NAME = t;
let e = s;
export {
  t as EVENT_NAME,
  e as default
};
//# sourceMappingURL=SampleTextChangeEvent.js.map
